/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {FC} from 'react'
import {SettingPage} from '../../component/setting'

const SettingWrapper: FC = () => {
  return (
    <div>
      <SettingPage />
    </div>
  )
}

export {SettingWrapper}
